var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "wkb-factor-loadings" }, [
    _c("h4", { staticClass: "wkb-inspector-section-heading" }, [
      _vm._v("Factor loadings"),
    ]),
    _c("div", { staticClass: "wkb-factor-loadings-toolbar" }, [
      _c(
        "div",
        {
          staticClass: "wkb-factor-loadings-tabs",
          attrs: { role: "tablist", "aria-label": "Factor loading tables" },
        },
        [
          _c(
            "button",
            {
              staticClass: "wkb-factor-loadings-tab",
              class: { "is-active": _vm.activeTab === "genes" },
              attrs: {
                id: _vm.tabId("genes"),
                type: "button",
                role: "tab",
                "aria-selected": _vm.activeTab === "genes" ? "true" : "false",
                "aria-controls": _vm.panelId,
              },
              on: {
                click: function ($event) {
                  _vm.activeTab = "genes"
                },
              },
            },
            [_vm._v(" Genes ")]
          ),
          _c(
            "button",
            {
              staticClass: "wkb-factor-loadings-tab",
              class: { "is-active": _vm.activeTab === "gene_sets" },
              attrs: {
                id: _vm.tabId("gene_sets"),
                type: "button",
                role: "tab",
                "aria-selected":
                  _vm.activeTab === "gene_sets" ? "true" : "false",
                "aria-controls": _vm.panelId,
              },
              on: {
                click: function ($event) {
                  _vm.activeTab = "gene_sets"
                },
              },
            },
            [_vm._v(" Gene sets ")]
          ),
        ]
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "wkb-factor-loadings-panel",
        attrs: {
          id: _vm.panelId,
          role: "tabpanel",
          "aria-labelledby": _vm.tabId(_vm.activeTab),
        },
      },
      [
        _vm.loading
          ? _c("p", { staticClass: "wkb-inspector-note" }, [
              _c("span", {
                staticClass: "wkb-inspector-spinner",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" Loading factor genes and gene sets… "),
            ])
          : _vm.error
          ? _c(
              "p",
              { staticClass: "wkb-inspector-note wkb-inspector-note--warn" },
              [_vm._v(" " + _vm._s(_vm.error) + " ")]
            )
          : _vm.payload
          ? [
              _vm.activeTab === "genes"
                ? _c("WorkspaceEvidenceTable", {
                    key: `${_vm.safeNodeKey}-genes`,
                    attrs: {
                      title: "Factor genes",
                      rows: _vm.payload.top_genes || [],
                      columns: _vm.geneColumns,
                      "page-size": 10,
                      "pagination-label": "Factor gene pages",
                      "empty-note": "No factor gene loadings were returned.",
                    },
                  })
                : _c("WorkspaceEvidenceTable", {
                    key: `${_vm.safeNodeKey}-gene-sets`,
                    attrs: {
                      title: "Factor gene sets",
                      rows: _vm.payload.top_gene_sets || [],
                      columns: _vm.geneSetColumns,
                      "page-size": 10,
                      "pagination-label": "Factor gene set pages",
                      "empty-note":
                        "No factor gene set loadings were returned.",
                    },
                  }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }